import React, { ReactElement } from 'react'
import { Flex, Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import ButtonArrow from 'images/button-arrow-right.svg'
import { navigate } from 'gatsby'
import Logo from 'images/organization/features/malware/logo-with-gradient.svg'
import Gradient from 'images/organization/features/malware/get-started-gradient.svg'
import StarsWrapper, { bigStarStyles } from 'components/Organization/HomePage/StarsWrapper'

export default function ReadyToGetStarted(): ReactElement {
  return (
    <Flex
      className="ios-scrolling-glitches-fix"
      data-testid="ready-to-get-started"
      sx={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '2.1rem',
        position: 'relative',
        backgroundColor: 'blue800',
        borderColor: 'blueYonder20',
        px: ['1.6rem', '1.6rem', 0],
      }}
    >
      <Svg
        svg={Gradient}
        sx={{
          position: 'absolute',
          zIndex: 'zIndex0',
        }}
        descriptiveText="Background gradient effect for get started section"
      />
      <StarsWrapper
        starsSx={[
          {
            top: '15rem',
            left: '-2.5rem',
          },
          {
            top: '22.7rem',
            right: '-5.1rem',
            ...bigStarStyles,
          },
        ]}
      >
        <Flex
          sx={{
            backgroundColor: 'blue80',
            width: '76rem',
            zIndex: 'pricingModal',
            border: '1px solid',
            borderColor: 'blueYonder20',
            borderRadius: '1rem',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <Flex
            sx={{
              width: ['auto', '48rem'],
              flexDirection: 'column',
              my: '4rem',
              mx: ['1.2rem', 0],
              gap: '2.4rem',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <Svg svg={Logo} descriptiveText="Company logo" />
            <Text
              variant="size19Weigh600Line138"
              as="h2"
              sx={{
                color: 'aliceBlue',
              }}
            >
              Ready to get started? Get a trial now.
            </Text>
            <Flex
              sx={{
                gap: '1.6rem',
                alignContent: ['center', 'center', 'flex-start'],
                flexDirection: ['column', 'column', 'row'],
              }}
            >
              <Button
                data-testid="take-it-now-button"
                sx={{ whiteSpace: 'nowrap' }}
                variant="gradientButton"
                ariaLabel="Start Free Trial"
                name="Start Free Trial"
                onClick={() => navigate('/onboard')}
              >
                <Text>Start Free Trial</Text>
                <Svg
                  svg={ButtonArrow}
                  sx={{
                    ml: '0.6rem',
                  }}
                  descriptiveText="Right arrow icon for Start Free Trial button"
                />
              </Button>
            </Flex>
          </Flex>

          <Flex
            sx={{
              flexDirection: ['column', 'row'],
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTop: '1px solid',
              borderColor: 'blueYonder20',
              gap: ['1.6rem', 0],
              py: ['4rem', '1.6rem'],
              px: '2.4rem',
            }}
          >
            <Text
              variant="size16Weight400Line140"
              sx={{
                textAlign: 'center',
                color: 'lightSteelBlue',
              }}
            >
              Need some help or want a demo?
            </Text>

            <Button
              ariaLabel="Contact us"
              name="Contact us"
              variant="roundedTertiary"
              sx={{ width: 'auto' }}
              onClick={() => navigate('/contact')}
            >
              Contact us
            </Button>
          </Flex>
        </Flex>
      </StarsWrapper>
    </Flex>
  )
}
